import { getRwg } from './rwgStore';

/**
 * Whether this visit arrived from a Reserve with Google link whose token is
 * still within its attribution window.
 *
 * This is the only question the rest of the app asks of this module — what to
 * do with the answer belongs to the caller, not here.
 */
export const isGoogleSourcedVisit = (): boolean => getRwg() !== null;
